const INDEX_ITEMS = [
  { letter: 'A', items: ['暗夜猎魔人：觉醒', '暗影之刃', '爱上吸血鬼'] },
  { letter: 'B', items: ['霸道总裁的契约新娘', '不败战神', '玻璃城堡'] },
  { letter: 'C', items: ['虫虫原创精选', '穿越之修仙', '初恋那件小事'] },
  { letter: 'D', items: ['大神来也', '斗罗大陆外传', '都市妖奇谈'] },
  { letter: 'E', items: ['恶魔之吻', '二次元恋爱', '恶魔契约'] },
  { letter: 'F', items: ['风起苍岚', '废柴逆袭', '非人哉同人'] },
  { letter: 'G', items: ['国民老公', '诡秘之主', '古风奇谈'] },
  { letter: 'H', items: ['狐妖大人请留步', '火影忍者同人', '花千骨漫画版'] },
  { letter: 'M', items: ['秘密花园的秘密', '魔道祖师', '名侦探柯南同人'] },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            漫画索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按字母检索<strong>免费漫画</strong>大全，快速找到你想看的<strong>好看的漫画</strong>
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {INDEX_ITEMS.map((group) => (
              <div
                key={group.letter}
                className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">
                    {group.letter}
                  </span>
                  <span className="text-xs text-foreground-500">{group.items.length}部作品</span>
                </div>
                <ul className="space-y-2">
                  {group.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#hero"
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mt-6 text-center">
            <p className="text-sm text-foreground-500">
              以上为精选索引，完整<strong>韩漫日漫国漫大全</strong>请访问平台查看全部作品
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}